import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createRenewalReportSlice = (set, get) => ({
    renewalReport: {
        loading: false,
        data: {},
    },
    getBusinessRenewalReport: async () => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ renewalReport: { ...state.renewalReport, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: "/v1/business/business-Renewal-report",
                headers: { token },
            });
            set(state => ({ renewalReport: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ renewalReport: { ...state.renewalReport, loading: false } }));
        }
    }
});
